<script setup lang="ts">
import IconSprite from '@/uiKit/IconSprite.vue'
import { RouterLink } from 'vue-router'

defineProps<{
  hubId: string
}>()
</script>

<template>
  <RouterLink
    :to="{
      name: 'Hub',
      params: {
        hubId,
      },
    }"
    class="rounded-corner-4 p-0.5 hover:bg-background-transparent-hovered focus:outline-hidden focus-visible:bg-background-transparent-pressed"
    aria-label="Go to hub"
    @click.stop
  >
    <IconSprite
      icon="link"
      size="xs"
    />
  </RouterLink>
</template>
